import React, { ReactNode } from 'react';
import styles from './styles.module.css';
import PageCardHeader from './PageCardHeader';

export default function PageCard({
  children,
  className = '',
  title,
  text,
  aside,
  backgroundIcon = '#fff',
  icon,
  iconClass = '',
  titleClass = '',
  textClass = '',
  noIconWidth = false,
  headClass = '',
  onClick,
}: {
  children?: ReactNode;
  className?: string;
  title?: string | ReactNode;
  text?: string | ReactNode;
  aside?: ReactNode;
  backgroundIcon?: string;
  icon?: ReactNode;
  iconClass?: string;
  titleClass?: string;
  textClass?: string;
  noIconWidth?: boolean;
  headClass?: string;
  onClick?: () => void;
}) {
  return (
    <div className={`${styles.card} card  ${className || ''}`} onClick={onClick}>
      <div className={`${styles.header} ${children && styles.headerMargin} `}>
        <PageCardHeader
          title={title}
          text={text}
          backgroundIcon={backgroundIcon}
          icon={icon}
          iconClass={iconClass}
          titleClass={titleClass}
          noIconWidth={noIconWidth}
          textClass={textClass}
          className={headClass}
        />
        {aside}
      </div>
      {children}
    </div>
  );
}
